"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Menu, X } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden md:flex gap-1">
        <div className="h-9 w-16 bg-muted-light/20 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted-light/20 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted-light/20 animate-pulse rounded-md" />
      </div>;
  }
  return <>
      {}
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList>
          {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="relative px-4 py-2 text-sm font-medium text-foreground transition-all duration-[var(--duration-medium)] hover:text-primary after:absolute after:bottom-0 after:left-1/2 after:h-0.5 after:w-0 after:bg-primary after:transition-all after:duration-[var(--duration-medium)] after:-translate-x-1/2 hover:after:w-3/4">
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <Button variant="ghost" size="icon" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden" aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
      </Button>

      {}
      {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-background border-b shadow-medium md:hidden z-50">
          <nav className="container mx-auto px-4 py-4 flex flex-col gap-2">
            {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="px-4 py-2 text-sm font-medium text-foreground hover:bg-accent rounded-md transition-colors" onClick={() => setMobileMenuOpen(false)}>
                {item.label}
              </Link>)}
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header className={`sticky top-0 w-full bg-background border-b border-border z-40 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${scrolled ? "shadow-medium" : ""}`}>
      <div className={`container mx-auto px-4 h-full flex items-center justify-between transition-all duration-[var(--duration-medium)] ${scrolled ? "py-2" : "py-2.5"}`}>
        <Link to="/" className="flex items-center">
          <img src="https://aerolimpio.com/wp-content/uploads/2026/01/Screenshot-2026-01-13-at-21.18.18.png" alt="Aqua Drone Col" className="h-20 my-[1mm]" />
        </Link>

        <div className="flex items-center gap-6">
          <MenuProvider menu_id="21">
            <HeaderMenuConsumer />
          </MenuProvider>

          <Button asChild className="hidden md:inline-flex transition-all duration-[var(--duration-medium)] hover:-translate-y-0.5">
            <Link to="https://wa.me/1234567890">Solicitar diagnóstico gratuito</Link>
          </Button>
        </div>
      </div>
    </header>;
}